import React from 'react';

import { Icon } from '../icon/Icon';
import { Delete, QuestionMark } from '../icons';
import { IconTooltip, OverflowTooltip } from '../tooltip';
import styles from './Button.module.scss';

interface OpinionLinkButtonProps {
    open: () => void;
    remove: () => void;
    buttonLabel: string;
    header: string;
    showRemove: boolean;
}

export const OpinionLinkButton: React.FC<OpinionLinkButtonProps> = ({
    open,
    remove,
    buttonLabel,
    header,
    showRemove
}) => (
    <div className={styles.opinionLinkWrapper}>
        <div className={styles.opinionLinkHeader}>
            {header}
            <IconTooltip icon={QuestionMark} fontSize={18} content='If this bespoke opinion supplements an already existing opinion, you can link it here.' />
        </div>
        <div className={styles.buttonWrapper}>
            <button onClick={open} className={styles.linkButton}>
                <OverflowTooltip overlayText={buttonLabel} />
            </button>
            {showRemove &&
                <button className={styles.removeLink} onClick={remove}>
                    <Icon icon={Delete} fontSize={25} />
                </button>
            }
        </div>
    </div>
);
